var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames';
import React from 'react';
import TouchFeedback from 'rmc-feedback';
import Icon from '../icon';
export default class IconButton extends React.Component {
    constructor(props) {
        super(props);
        this.btnSize = (btnSize, type) => {
            let height, width;
            if (type === "ellipse") {
                height = btnSize > 20 ? btnSize : 20;
                width = height * 4;
            }
            else {
                height = btnSize;
                width = height;
            }
            return {
                height,
                width,
            };
        };
        this.textSize = (btnSize, type, iconType) => {
            let size;
            if (type === "ellipse") {
                size = `${0.575 * btnSize}`;
            }
            else {
                if (!iconType) {
                    size = 0.2 * btnSize;
                }
                else {
                    size = 0.14 * btnSize;
                }
            }
            return size;
        };
        this.contentSize = (btnText, type, btnSize) => {
            let content = btnText ? btnText.length > 4 ? `${btnText.slice(0, 4)}` : btnText : "";
            if (type !== "ellipse" && btnSize <= 55) {
                content = btnText ? btnText.length > 4 ? `${btnText.slice(0, 2)}...` : btnText : "";
            }
            return content;
        };
    }
    render() {
        const _a = this.props, { prefixCls, children, className, custIcon, text, iconType, btnType, size, disabled, textStyle = {
            // fontFamily: "PingFangSC-Regular",
            color: "#fff",
        }, btnStyle = {
            border: "1px solid #000",
            backgrounColor: "",
        }, onClick, activeClassName = 'bs-icon-button-active' } = _a, restProps = __rest(_a, ["prefixCls", "children", "className", "custIcon", "text", "iconType", "btnType", "size", "disabled", "textStyle", "btnStyle", "onClick", "activeClassName"]);
        const wrapCls = classnames(prefixCls, className);
        const btnText = text ? String(text) : null;
        const btnSize = Number(size);
        const type = String(btnType);
        const { color = "#fff", } = textStyle;
        const { 
        // border = "1px solid #000",
        backgrounColor = "", } = btnStyle;
        const btnHeight = this.btnSize(btnSize, type).height;
        const btnWidth = this.btnSize(btnSize, type).width;
        const buttonStyle = {
            width: `${btnWidth}px`,
            height: `${btnHeight}px`,
            //border: `${type === "ellipse" ? border : ""}`,
            background: "#108ee9",
            backgrounColor,
        };
        const contentStyle = {
            fontSize: `${this.textSize(btnSize, type, iconType)}px`,
            color,
        };
        const btnTypeCls = type === "ellipse" ? `${prefixCls}-icon-button-row` : `${prefixCls}-icon-button-column`;
        const buttonText = this.contentSize(btnText, type, btnSize);
        const iconStyle = (!btnText && type !== "ellipse") ? { width: "50%", height: "50%", marginBottom: "0" } : {};
        const iconEle = iconType ? typeof iconType === "string" ? React.cloneElement(<Icon type={iconType}/>, { className: `${prefixCls}-icon-button-icon`, style: iconStyle }) : iconType : null;
        const extraCls = {
            [`${prefixCls}-disabled`]: disabled,
        };
        return (<div className={wrapCls}>
          <div className={classnames(`${prefixCls}-icon-button-wrapper`, extraCls)} {...restProps}>
            <TouchFeedback activeClassName={activeClassName}>
              <div className={btnTypeCls} style={buttonStyle} onClick={onClick}>
                {iconEle}
                <div className={`${prefixCls}-icon-button-text`} style={contentStyle}>{buttonText}</div>
              </div>
            </TouchFeedback>
          </div>
        </div>);
    }
}
IconButton.defaultProps = {
    prefixCls: "bs-icon-button",
    size: 'small',
};



// WEBPACK FOOTER //
// ./components/icon-button/index.tsx